import {Card, Carousel} from "react-bootstrap";

const Schedule = () => {

    return (
        <div>
            <div className={"header"}>
                <img className={"fire"} alt={"fire"} src={require("./resources/img/fire-icon.png")} />
                <span>Karaoke Schedule</span>
            </div>
            <div className={"schedule-cards"}>
                <Card className={"card"}>
                    <Card.Body>
                        <Card.Img variant="topLeft" src={require("./resources/img/timecapsule.jpg")} alt="" height={100} />
                        <Card.Title>Time Capsule<br />Bar & Grill</Card.Title>
                        <Card.Text>
                            <p>
                                3558 W Northern Ave, Phoenix, AZ
                            </p>
                            <hr />
                            <p>
                                Fridays<br />8pm - 1am<br />
                            </p>
                            <p>
                                Saturdays<br />8pm - 1am
                            </p>
                        </Card.Text>
                    </Card.Body>
                </Card>
                <Card className={"card"}>
                    <Card.Body>
                        <Card.Img variant="topLeft" src={require("./resources/img/gametime.jpg")} alt="" height={100} />
                        <Card.Title>Game Time Bar & Grill</Card.Title>
                        <Card.Text>
                            <p>
                                6750 W Olive Ave<br />UNIT 101, Peoria, AZ
                            </p>
                            <hr />
                            <p>
                                Wednesdays<br />8:30pm - 1am<br />
                            </p>
                            <p>
                                Thursdays<br />8:30pm - 1am
                            </p>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </div>
            <div className={"gallery"}>
                <Carousel>
                    <Carousel.Item>
                        <img src={require("./resources/img/davepic1.jpg")}  height={500}/>
                        <Carousel.Caption>
                            <h3>Droppin' the beat</h3>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={require("./resources/img/davepic4.jpg")}  height={500}/>
                        <Carousel.Caption>
                            <h3>Lovin' the mix</h3>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={require("./resources/img/oldpeople.jpg")} height={300}/>
                        <Carousel.Caption>
                            <h3>Elderly Facility Party</h3>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={require("./resources/img/corpevent.jpg")}  height={500}/>
                        <Carousel.Caption>
                            <h3>Corporate Event</h3>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={require("./resources/img/girlsinging.jpg")} height={500}/>
                        <Carousel.Caption>
                            <h3>Hittin' the high note</h3>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={require("./resources/img/daveevents.jpg")} height={500}/>
                        <Carousel.Caption>
                            <h3>Specialized Events</h3>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel>
            </div>
        </div>
    )

}; export default Schedule;